const Task = (props) => {
	const task = props.task
	const name = task.name
	const completed = task.completed ? 'Concluída' : 'Em Andamento'
	const formatedDate =
		task.completed_at?.split('T')[0].replace(/['"]+/g, '').split('-').reverse().join('-') || 'Sem Data'

	return (
		<tr className="task-items">
			<td>{name}</td>
			<td>{formatedDate}</td>
			<td className={task.completed ? 'green' : 'red'}>{completed}</td>
		</tr>
	)
}

export default Task
